var exports = {
  "kL": "xe533113f--ef4f41--container",
  "Qs": "xe533113f--ef4f41--content",
  "DD": "xe533113f--ef4f41--title",
  "VA": "xe533113f--ef4f41--subtitle",
  "Sl": "xe533113f--ef4f41--image",
};

module.exports = exports;
